import classNames from 'classnames';

interface MarginExampleProps {
    className: string;
}

export const MarginExample = ({ className }: MarginExampleProps) => (
    <div className="sds_margin__outline">
        <div className={classNames('sds_margin', className)} />
    </div>
);
